const boxheight = (...elements) => {
    let tmpArray = [];
    for (let element of elements[0]) {
        // recupero gruppi di data-sameheight
        let sameheightvalue = element.getAttribute('data-sameheight');
        tmpArray[sameheightvalue] = sameheightvalue;
    }
    const datasameheight = tmpArray.filter(el => {
        return el != null && el != '';
    });
    for (let datash of datasameheight) {
        let elements = document.querySelectorAll(`[data-sameheight='${datash}']`);
        let height = 0;
        for (let element of elements) {
            element.style.height = 'auto';
            if (element.offsetHeight > height) height = element.offsetHeight;
        }
        for (let element of elements) {
            element.style.height = `${height}px`
        }
    }
}

export { boxheight as default };
